import { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './RouteMenuButton.module.css';
import { useLocation } from "react-router-dom";
import { Box, ListItem, Stack, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

class RouteMenuButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.index) {
            this.active = this.props.location.pathname === '/' || this.props.location.pathname === this.props.to;
        } else {
            this.active = this.props.location.pathname === this.props.to;
        }
        return <ListItem sx={{ paddingX: 1.5, paddingBottom: 0 }}>
            <Link to={this.props.to} underline="none" style={{ textDecoration: 'none', width: '100%' }}>
                <Stack direction="row" title={this.props.children} style={{
                    '--gcm-btn-color': this.props.theme.palette.mariano.secondary,
                    '--gcm-btn-bgcolor': this.props.theme.palette.mariano.secondary,
                    '--gcm-active-color': this.props.theme.palette.primary.main,
                    '--gcm-active-bgcolor': this.props.theme.palette.mariano.secondary,
                }} className={[styles.menuBtn, this.active ? styles.active : '']} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {this.props.icon}
                    {/* <Typography ml={1} variant="caption">{this.props.children}</Typography> */}
                </Stack>
            </Link>
        </ListItem>
    }
}

const wrapper = Component => props => {
    const location = useLocation();
    const theme = useTheme();
    return <Component {...props} location={location} theme={theme} />;
};

export default wrapper(RouteMenuButton);